import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import ExpertiseTable from "../../components/ExpertiseTable";
import {getExpertiseList} from "../../store/actions";
import {makeStyles} from "@material-ui/core/styles";

const items = [
  {
    label: "Конструктор КиОП",
    link: "/work/app/constructor"
  },
  {
    label: "Экспертиза",
    link: "/work/app/constructor/expertise"
  },
];

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const ExpertiseList = ({ history,
                         getExpertiseList,
                         expertiseList
                       }) => {
  const {root} = useStyles();

  useEffect(() => {
    getExpertiseList();
  }, []);

  return (
    <div>
      <Breadcrumbs items={items} />
      <div className={root}>
        {expertiseList &&
        <ExpertiseTable expertiseList={expertiseList}
                        getExpertiseList={getExpertiseList}/>}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  expertiseList: state.expertise.expertiseList
});

const mapDispatchToProps = dispatch => ({
  getExpertiseList: () => dispatch(getExpertiseList())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpertiseList);
